(function () {
  if (window.__tathaGoesWellWithAddBound) return;
  window.__tathaGoesWellWithAddBound = true;

  document.addEventListener(
    'click',
    function (evt) {
      var button = evt.target.closest('[data-goes-well-with-add]');
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

      var variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;

      evt.preventDefault();

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        if (cart.tagName === 'CART-DRAWER' && typeof cart.open === 'function' && !cart.classList.contains('active')) {
          // Open immediately to avoid perceived lag before drawer appears.
          cart.open(button);
        }
        formData.append(
          'sections',
          cart.getSectionsToRender().map(function (section) {
            return section.id;
          }),
        );
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(document.activeElement);
        }
      }
      config.body = formData;

      button.classList.add('is-loading');
      button.setAttribute('aria-disabled', 'true');

      fetch(window.routes.cart_add_url, config)
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'goes-well-with-add',
              productVariantId: variantId,
              errors: response.errors || response.description,
              message: response.message,
            });
            var msg = button.getAttribute('data-add-error-msg') || response.description || response.message || '';
            if (msg) window.alert(msg);
            return;
          }

          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }

          var startMarker =
            typeof CartPerformance !== 'undefined' && CartPerformance.createStartingMarker
              ? CartPerformance.createStartingMarker('add:wait-for-subscribers')
              : null;

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'goes-well-with-add',
            productVariantId: variantId,
            cartData: response,
          }).then(function () {
            if (startMarker && CartPerformance.measureFromMarker) {
              CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
            }
            if (typeof cart.renderContents === 'function') {
              cart.renderContents(response);
            }
          });

          if (cart.classList && cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
          }
        })
        .catch(function (err) {
          console.error(err);
          var fallback = button.getAttribute('data-add-error-msg');
          if (fallback) window.alert(fallback);
        })
        .finally(function () {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-disabled');
        });
    },
    false,
  );
})();
